import React, { useState, useEffect } from 'react';

const ImageUpload = (props) => {
    const [uploading, setUploading] = useState(false);
    const [image, setImage] = useState({});
    const [errored, setErrored] = useState(false);

    let componentIdentifier = typeof props.uniqueIdentifier !== 'undefined' ? '_'+props.uniqueIdentifier : '';
    let textContent = props.textContent ? props.textContent : 'Add a photo from camera roll';

    useEffect(() => {
    	if (typeof props.image !== 'undefined') {
			setImage(props.image);
		}
		else if (!jQuery.isEmptyObject(image)) {
			setImage({});
		}
    }, [props.image]);

    const onChange = (e) => {
        const publishButton = $('#publish-button');

		const errs = [];
		const files = Array.from(e.target.files);
		const formData = new FormData();
		const types = ['image/png', 'image/jpeg', 'image/gif'];

		files.forEach((file, i) => {
			if (types.every(type => file.type !== type)) {
				errs.push(file.type + ' is not a supported format');
			}

			if (file.size > 15000000) {
				errs.push(file.name + ' is too large, please pick a smaller file');
			}

			formData.append(i, file)
		});

		if (typeof props.type !== 'undefined') {
			formData.append('type',props.type);
		}

		if (errs.length) {
			// there were errors
			setErrored(errs[0]);
			props.onError(true);
		}
		else {
			// Upload to server. Return path to form.
			setUploading(true);
			setErrored(false);

            publishButton.hide();

			fetch('/default/ajax?ajax=react_image_upload', {
				method: 'POST',
				body: formData
			})
		    .then(res => res.json())
		    .then(
		        (data) => {
                    setUploading(false);

				    if (data.result === 'success') {
				    	setImage(data.image)

						publishButton.show();

						if (typeof props.onFinish === 'function') {
							props.onFinish(data);
						}
				    }
				    else if (data.error) {
				    	setErrored(`There was an error uploading this file: ${data.error}`);
				    }
				    else {
				    	setErrored('There was an error uploading this file');
				    }
		        },
		        // Note: it's important to handle errors here
		        // instead of a catch() block so that we don't swallow
		        // exceptions from actual bugs in components.
		        (error) => {
                    setUploading(false);
                    setErrored(error);
		        }
		    )	
		}	
    }

    return (
        <>
            {uploading ? (
                <div className="text-nowrap">
					<span className="spinner-border spinner-border-sm"></span> Please wait, your image is uploading..
                </div>
            ) : (
                <div>
					{errored && (
						<div>
							Error: {errored}
						</div>
					)}
					{image.path && (
						<input type="hidden" name={"file_path" + componentIdentifier} value={image.path} />
					)}
					<div>
						<label htmlFor={"single" + componentIdentifier}>
							<div className="mvm-btn py-2 px-3">
								{image.name ?? textContent}
							</div>
							<input type="file" onChange={(e) => onChange(e)} id={"single" + componentIdentifier} style={{visibility:'hidden',width:10,position:'absolute'}} /> 
						</label>
					</div>
				</div>
            )}
        </>
    )
}

export default ImageUpload;